export default "__VITE_ASSET__BjhsCTHJ__"